/* eslint-disable import/no-default-export */
import { combineReducers } from 'redux';

import alerts, { AlertsState } from './alerts';
import boardSelector, { BoardSelectorState } from './board-selector';
import boardsMenu, { BoardsMenuState } from './boards-menu';
import closedBoards, { ClosedBoardsState } from './closed-boards';
import collapsibles, { CollapsiblesState } from './collapsibles';
import createMenu, { CreateMenuState } from './create-menu';
import errors, { ErrorState } from './errors';
import header, { HeaderState } from './header';
import labels, { LabelUiState } from './labels';
import navigating, { NavigatingState } from './navigating';
import notificationsPane, {
  NotificationsPaneState,
} from './notifications-pane';
import overlay, { OverlayState } from './overlay';
import search, { SearchUiState } from './search';
import {
  MemberHomeProfileState,
  MemberHomeProfileReducer as memberHomeProfile,
} from 'app/gamma/src/modules/state/ui/member-home-profile';

export interface UiState {
  alerts: AlertsState;
  boardSelector: BoardSelectorState;
  boardsMenu: BoardsMenuState;
  closedBoards: ClosedBoardsState;
  collapsibles: CollapsiblesState;
  createMenu: CreateMenuState;
  errors: ErrorState;
  header: HeaderState;
  labels: LabelUiState;
  memberHomeProfile: MemberHomeProfileState;
  navigating: NavigatingState;
  notificationsPane: NotificationsPaneState;
  overlay: OverlayState;
  search: SearchUiState;
}

export default combineReducers({
  alerts,
  boardSelector,
  boardsMenu,
  closedBoards,
  collapsibles,
  createMenu,
  errors,
  labels,
  header,
  memberHomeProfile,
  navigating,
  notificationsPane,
  overlay,
  search,
});
